module.exports = __webpack_public_path__ + "img/dry-hairy-tree-04.8272ca73.png";